import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {updateSingleDesign} from "../../services/design-data-service";
import {
    getAllDesignVariants,
    getSingleDesignVariant,
    updateSingleDesignVariant
} from "../../services/design-variant-data-service";
import PublisherDesignVariantList from "../publisher/publisher-design-variant-list";
import PreviewDesignVariant from "./preview-design-variant";
import {ArrowDownOnSquareIcon, XMarkIcon} from "@heroicons/react/24/solid";
import ShowDesignDetail from "../common/show-design-detail";
import ApplyParentProductColorListBox from "../common/apply-parent-product-color-list-box";
import {DOWNLOAD_DESIGN_VARIANT_TIME_DELAY, SAVE_DESIGN_TIME_DELAY} from "../../constants/design.constant";
import {processDesignVariantStatistics} from "../../utils/design-util";
import Promise from "bluebird";
import {prepareDesignVariantLabel, prepareImageFileName} from "../../utils/design-variant-util";


const DownloadDesignVariants = ({
                                    isLightButton,
                                    designDetail,
                                    setDesignDetail,
                                    parentProduct,
                                    isAssignColors,
                                    isPreview,
                                    updateVariantColorsInDesign
                                }) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedVariant, setSelectedVariant] = useState(null);
    const [designVariantDetail, setDesignVariantDetail] = useState(null);
    const [selectedProductColor, setSelectedProductColor] = useState(null);
    let [changesCount, setChangesCount] = useState(0);
    const [statusChangeInProgress, setStatusChangeInProgress] = useState(false);
    const [downloadAllVariants, setDownloadAllVariants] = useState(false);

    const handleCloseAction = () => {
        setDownloadAllVariants(false);
        setShowModal(false);
    }

    useEffect(() => {
        if (showModal) {
            setDownloadAllVariants(false);
            setSelectedVariant(designDetail?.variants[0]);

            if (designDetail?.variants[0] && designDetail?.variants[0]?.colors) {
                setSelectedProductColor(designDetail?.variants[0]?.colors[0] || null);
            }
        }
    }, [showModal]);

    const incrementChangesCount = () => {
        setChangesCount(++changesCount);
    }

    const resetChangesCount = () => {
        setChangesCount(0);
    }

    const getDesignVariantById = () => {
        if (selectedVariant) {
            getSingleDesignVariant(selectedVariant?.id)
                .then(async response => {
                    const designVariantDetailData = _.cloneDeep(response.data());
                    setDesignVariantDetail(designVariantDetailData);
                });
        }
    }

    useEffect(() => {
        getDesignVariantById();
    }, [selectedVariant]);

    useEffect(() => {
        if (isAssignColors) {
            incrementChangesCount();
        }
    }, [designVariantDetail]);

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {

                if (isAssignColors && changesCount > 0) {
                    resetChangesCount();
                    saveDesignVariantChanges();
                }

            }, SAVE_DESIGN_TIME_DELAY);

        return () => clearTimeout(timeoutId);
    }, [changesCount]);

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {
                if (showModal && downloadAllVariants) {

                    let nextIndex = 0;
                    let currentDesignDetail = {...designDetail};
                    let currentDesignVariant = {...selectedVariant};

                    if (currentDesignVariant) {
                        const currentIndex = _.findIndex(currentDesignDetail?.variants, ['key', currentDesignVariant.key]);
                        nextIndex = currentIndex + 1;
                    }

                    if (currentDesignDetail && currentDesignDetail?.variants.hasOwnProperty(nextIndex)) {
                        setSelectedVariant(currentDesignDetail?.variants[nextIndex]);
                    } else {
                        setDownloadAllVariants(false);
                        setSelectedVariant(null);
                    }
                }

            }, DOWNLOAD_DESIGN_VARIANT_TIME_DELAY);

        return () => clearTimeout(timeoutId);
    });

    const saveDesignVariantChanges = async () => {
        let existingDesignVariant = {...designVariantDetail};

        if (!_.isEmpty(existingDesignVariant)) {
            await updateSingleDesignVariant(existingDesignVariant);
        }
    }

    const removeSelectedProductColorFromVariant = (productColor) => {
        setSelectedProductColor(null);
        const existingDesignVariantDetail = {...designVariantDetail};
        const existingColors = existingDesignVariantDetail.colors || [];

        const colorIndex = _.findIndex(existingColors, ['name', productColor.name]);

        if (colorIndex !== -1) {
            delete existingColors[colorIndex];
        }

        existingDesignVariantDetail.colors = _.orderBy(_.compact(existingColors), 'name');

        setDesignVariantDetail(existingDesignVariantDetail);
        updateVariantColorsInDesign(existingDesignVariantDetail);
    }

    const addSelectedProductColorToVariant = (productColor) => {
        setSelectedProductColor(productColor);
        const existingDesignVariantDetail = {...designVariantDetail};
        const existingColors = existingDesignVariantDetail.colors || [];

        const colorIndex = _.findIndex(existingColors, ['name', productColor.name]);
        const updatedProductColor = _.cloneDeep(productColor);

        if (colorIndex === -1) {
            existingColors.push(updatedProductColor);
        } else {
            existingColors[colorIndex] = updatedProductColor;
        }

        existingDesignVariantDetail.colors = _.orderBy(existingColors, 'name');

        setDesignVariantDetail(existingDesignVariantDetail);
        updateVariantColorsInDesign(existingDesignVariantDetail);
    }

    const handleMarkAsReadyToPublish = () => {
        const existingDesignVariantDetail = {...designVariantDetail};
        existingDesignVariantDetail.status = 'ready-to-publish';

        setDesignVariantDetail(existingDesignVariantDetail);
        updateVariantInDesign(existingDesignVariantDetail);
    }

    const updateVariantInDesign = async (existingDesignVariant) => {
        const existingDesignDetail = {...designDetail};
        const existingVariants = existingDesignDetail.variants;

        const variantIndex = _.findIndex(existingVariants, ['key', existingDesignVariant.key]);
        existingVariants[variantIndex].status = existingDesignVariant.status;
        existingDesignDetail.variants = existingVariants;
        processDesignVariantStatistics(existingDesignDetail);

        if (setDesignDetail) {
            setDesignDetail(existingDesignDetail);
        }

        await updateSingleDesign(existingDesignDetail);
    }

    const markAllDesignVariantsAsReadyToPublish = async () => {
        setStatusChangeInProgress(true);
        const designVariantListResult = await getAllDesignVariants(designDetail?.id);

        const existingDesignDetail = {...designDetail};
        _.forEach(existingDesignDetail.variants, variant => {
            prepareDesignVariantLabel(variant, existingDesignDetail);
            variant.status = 'ready-to-publish';
        });

        console.log({existingDesignDetail})
        processDesignVariantStatistics(existingDesignDetail);

        const variantsMap = _.keyBy(existingDesignDetail.variants, 'id');

        await Promise.mapSeries(designVariantListResult, async designVariant => {
            const variant = variantsMap[designVariant?.id];

            if (variant) {
                designVariant.status = variant.status;

                if (variant.colors) {
                    designVariant.colors = variant.colors;
                }

                prepareImageFileName(designVariant, existingDesignDetail);
                await updateSingleDesignVariant(designVariant);
            }
        });

        if (setDesignDetail) {
            setDesignDetail(existingDesignDetail);
        }

        await updateSingleDesign(existingDesignDetail);
        setStatusChangeInProgress(false);
    }

    return (
        <>
            {designDetail?.variants?.length > 0 &&
                <div className="flex items-center justify-center">
                    <button
                        className={`py-2 px-4 ${isLightButton ? 'button-outline-small' : 'button-gray'}`}
                        onClick={() => setShowModal(true)}>
                        {!isAssignColors && !isPreview &&
                            <span>Download</span>
                        }
                        {isAssignColors &&
                            <span>Assign Product Colors</span>
                        }
                        {isPreview &&
                            <span>Preview</span>
                        }
                    </button>
                </div>
            }

            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-4/5 my-10">
                            {/*content*/}
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex justify-between px-5 pt-4 rounded-t">
                                    <div className='flex justify-center items-center'>
                                        {!isAssignColors && !isPreview &&
                                            <h3 className="text-xl font-bold">Download Design Variants</h3>
                                        }
                                        {isAssignColors &&
                                            <h3 className="text-xl font-bold">Assign Product Colors</h3>
                                        }

                                        {isPreview &&
                                            <h3 className="text-xl font-bold">Preview Design Variants</h3>
                                        }
                                    </div>

                                    <div className="">
                                        <ShowDesignDetail designDetail={designDetail}/>
                                    </div>

                                    <div className="mr-2 ml-4 flex">
                                        <div className="mt-2 mr-2">
                                            <button onClick={() => {
                                                setDownloadAllVariants(true);
                                            }}
                                                    className="button-gray py-2 px-3 flex justify-center ml-2">
                                                <div className="pr-2">
                                                    <ArrowDownOnSquareIcon className="h-6 w-6"/>
                                                </div>
                                                Download All
                                            </button>
                                        </div>

                                        <div className="mt-2 mr-2">

                                            {statusChangeInProgress &&
                                                <button
                                                    disabled={statusChangeInProgress}
                                                    className="button-green-outline px-4 py-2 flex items-center justify-center w-56">
                                                    <div
                                                        className={`w-6 h-6 border-b-2 border-t-2 border-green-600 rounded-full animate-spin`}></div>
                                                    <div className="ml-2">Saving In Progress...</div>
                                                </button>
                                            }

                                            {!statusChangeInProgress && !isPreview &&
                                                <button
                                                    className="button-green px-3 py-2"
                                                    onClick={markAllDesignVariantsAsReadyToPublish}>
                                                    Mark All As Ready To Publish
                                                </button>
                                            }

                                        </div>

                                        <div className="mt-2">
                                            <button
                                                className="button-gray-outline px-3 py-2"
                                                onClick={handleCloseAction}>
                                                <div className="">
                                                    <XMarkIcon className="h-6 w-6"/>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {/*body*/}
                                <div
                                    className="relative px-6 pb-6">

                                    <div className="flex justify-center pt-4">

                                        <div className="items-center justify-start w-1/3">
                                            <PublisherDesignVariantList
                                                selectedVariant={selectedVariant}
                                                setSelectedVariant={setSelectedVariant}
                                                setSelectedProductColor={setSelectedProductColor}
                                                designDetail={designDetail}/>
                                        </div>

                                        <div className="items-center justify-start w-2/3 ml-4 mr-2">
                                            <PreviewDesignVariant
                                                designVariantDetail={designVariantDetail}
                                                selectedVariant={selectedVariant}
                                                productColor={selectedProductColor}
                                                downloadAllVariants={downloadAllVariants}
                                            />
                                        </div>

                                        {parentProduct &&
                                            <div
                                                className="w-1/3 bg-white ml-2 border border-gray-300 rounded mr-2">
                                                {!isAssignColors &&
                                                    <ApplyParentProductColorListBox
                                                        parentProduct={parentProduct}
                                                        selectedProductColor={selectedProductColor}
                                                        setSelectedProductColor={setSelectedProductColor}
                                                        selectedColors={selectedVariant?.colors}
                                                        addSelectedProductColorToVariant={undefined}
                                                        removeSelectedProductColorFromVariant={undefined}
                                                        containerClass={'preview-design-variant-container'}/>
                                                }
                                                {isAssignColors &&
                                                    <ApplyParentProductColorListBox
                                                        parentProduct={parentProduct}
                                                        selectedProductColor={selectedProductColor}
                                                        setSelectedProductColor={setSelectedProductColor}
                                                        selectedColors={selectedVariant?.colors}
                                                        addSelectedProductColorToVariant={addSelectedProductColorToVariant}
                                                        removeSelectedProductColorFromVariant={removeSelectedProductColorFromVariant}
                                                        containerClass={'preview-design-variant-container'}/>
                                                }
                                            </div>
                                        }

                                    </div>

                                </div>
                                {/*footer*/}
                                {/*<div
                                    className="flex items-center justify-center px-6 pb-6 rounded-b">
                                    <button
                                        className="ml-2 bg-green-500 text-white active:bg-green-600 h-10 rounded px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleCloseAction}>
                                        Close
                                    </button>
                                </div>*/}
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default DownloadDesignVariants
